import { Fragment } from "react";
import "./global-css.css";
import "./App.css";
import HomePage from "HomePage";

const App = () => {
  return (
    <Fragment>
      <HomePage />
    </Fragment>
  );
};

export default App;
